// Section 7: Interest & Finance
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Clock } from "lucide-react";

export const InterestFinanceSection = ({
  formData,
  handleChange
}) => {
  return (
    <Card className="rounded-sm shadow-sm border-l-4 border-l-amber-400" data-testid="quick-finance">
      <CardHeader className="pb-3 bg-amber-100 rounded-t-xl border-b border-amber-200">
        <CardTitle className="font-heading tracking-tight text-lg flex items-center gap-2 text-amber-900">
          <Clock className="h-5 w-5 text-muted-foreground" />
          7. Interest & Finance
        </CardTitle>
      </CardHeader>
      <CardContent className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="q-projectInterestRate">Project Interest Rate (% p.a.)</Label>
          <Input
            id="q-projectInterestRate"
            name="projectInterestRate"
            type="number"
            value={formData.projectInterestRate || ""}
            onChange={handleChange}
            placeholder="0"
            className="rounded-sm"
            data-testid="quick-interest-rate"
          />
          <p className="text-xs text-muted-foreground">Leave blank or 0 if not applicable</p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="q-stampDutyRate">Stamp Duty (%)</Label>
          <Input
            id="q-stampDutyRate"
            name="stampDutyRate"
            type="number"
            value={formData.stampDutyRate}
            onChange={handleChange}
            placeholder="5"
            className="rounded-sm"
            data-testid="quick-stamp-duty"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="q-registrationChargesRate">Registration (%)</Label>
          <Input
            id="q-registrationChargesRate"
            name="registrationChargesRate"
            type="number"
            value={formData.registrationChargesRate}
            onChange={handleChange}
            placeholder="1"
            className="rounded-sm"
            data-testid="quick-registration"
          />
        </div>
      </CardContent>
    </Card>
  );
};
